export default {
    company_agency: "Store",
    my_score: "My BitCORs",
    no_company_agency_found: "No stores found",
    "points,": "BitCOR",
    price: "BitCOR",
    project_name: "Academia Coral",
    score: "BitCOR"
}